module.exports = __webpack_public_path__ + "static/media/overlay2-50.a3eee56b.svg";